import { useRef, useEffect, useContext } from "react";

import classes from "./LoginForm.module.scss";
import ValidUserContext from "../authCheck";
import { UserIcon } from "./Icons";


let isInitial = true;

function SendEmailForm() {
  const validUserContext = useContext(ValidUserContext);

  const emailInputRef = useRef();

  useEffect(() => {
    if (isInitial) {
      validUserContext.localAuthCheck(true);
      isInitial = false;
    }
  }, [validUserContext]);

  const submitHandler = (event) => {
    event.preventDefault();
    validUserContext.apiSendPwdResetHandler(
        emailInputRef.current.value
    );
  };

  return (
    <div className={classes.logincontainer}>
      <form onSubmit={submitHandler} className={classes.form}>
        <div className={classes.loginInstructions}>Forgot password</div>
        <div className={classes.loginSubtitle}>
          Enter your email and we will send a reset link.
        </div>
        <label className={classes.field}>
          <UserIcon className={classes.fieldIcon} />
          <input
            className={classes.input}
            type="email"
            id="user-name"
            name="user-name"
            autoComplete="on"
            placeholder="Email"
            ref={emailInputRef}
            required={!validUserContext.isLoggedIn}
          />
        </label>
        <button
          className={classes.loginBtn}
          disabled={validUserContext.isLoggedIn || validUserContext.isLoggingIn}
        >
          {validUserContext.isLoggedIn ? "Already logged in" : "Send reset email"}
        </button>
        <button
          type="button"
          className={classes.linkBtn}
          onClick={validUserContext.reset}
        >
          Back to sign in
        </button>
      </form>
    </div>
  );
}

export default SendEmailForm;
